import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";

const ApproveVendor = ({ value, onClose, handleSubmit }) => {
  const userData = useSelector((state) => state?.user);
  const mobileView = useMediaQuery("(max-width:575px)");

  const validationSchema = Yup.object({
    userId: Yup.string().nullable().required("Please select staff"),
  });

  return (
    <>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Approving <strong>{value?.name}</strong> ({value?.mobileNumber}). This
        will allow them to log in to the App/Website.
      </Typography>
      <Formik
        initialValues={{ userId: value?.user?._id || null }}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1000);
        }}
      >
        {({ isSubmitting, touched, errors, values, handleChange, handleBlur }) => (
          <Form>
            <FormControl
              fullWidth
              sx={{ mb: 4 }}
              error={touched.userId && Boolean(errors.userId)}
            >
              <InputLabel id="approve-userId-label">
                Belongs To Staff*
              </InputLabel>
              <Select
                name="userId"
                labelId="approve-userId-label"
                id="userId"
                value={values.userId}
                label="Belongs To Staff"
                onChange={handleChange}
                onBlur={handleBlur}
              >
                {userData?.list
                  ?.filter?.((val) => val.type === value?.type)
                  ?.map((val) => (
                    <MenuItem key={val._id} value={val._id}>
                      {val.name}
                    </MenuItem>
                  ))}
              </Select>
              {touched.userId && errors.userId && (
                <FormHelperText>{errors.userId}</FormHelperText>
              )}
            </FormControl>
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              justifyContent="flex-end"
            >
              <LoadingButton
                variant="outlined"
                color="secondary"
                onClick={onClose}
                size="large"
                fullWidth={mobileView}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                type="submit"
                variant="contained"
                color="success"
                size="large"
                sx={{ mb: 3 }}
                loading={isSubmitting}
                loadingIndicator={<CircularProgress size={20} />}
                fullWidth={mobileView}
              >
                Approve
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ApproveVendor;
